import { Injectable } from '@angular/core';
import { GTMPageBlockTrackingModel } from '@libs/shared/models';
import { TrackingGoogleService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class PageBlockImpressionTrackerService {
  private readonly impressionsPushTimeout: number = 500;

  private readonly impressionsBuffer: GTMPageBlockTrackingModel[] = [];
  private pushTimer: number | null = null;

  public constructor(
    private readonly trackingService: TrackingGoogleService,
  ) {
  }

  public track(impression: GTMPageBlockTrackingModel): void {
    this.impressionsBuffer.push(impression);

    this.pushTimer ??= window.setTimeout(
      () => void this.pushPendingImpressions(),
      this.impressionsPushTimeout,
    );
  }

  private pushPendingImpressions(): void {
    this.pushTimer = null;
    this.trackingService.trackPageBlockImpressionEvent(...this.impressionsBuffer);
    this.impressionsBuffer.length = 0;
  }
}
